import { type Transition, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

export enum SuffixVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const suffixVariants: Variants = {
    [SuffixVariant.Hidden]: {
        opacity: 0,
        scale: 0,
    },
    [SuffixVariant.Show]: {
        opacity: 1,
        scale: 1,
    },
};

export const suffixTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.normal,
};
